import { useState, useContext } from "react";
import { Stack, Box, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";
//import from project
import "./dashboardstyle.scss";
import { getKhmerNumber, getKhmerMonth } from "../../Function/DynamicFn";
import { AuthContext } from "../../Context/AuthContext";
import EmptyData from "../Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import useGetRevenueByFilterDashboard from "../../Hooks/useGetRevenueByFilterDashboard";
import SelectMonthYear from "./SelectMonthYear";

export default function TotalIncomeGraph() {
  const { t, language } = useContext(AuthContext);
  const colors = ["#40d388", "#4dc4d9", "#6a62f3", "#f19251", "#40d388"];

  // console.log("language::", language);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [filterType, setFilterType] = useState("month");
  const [filterYear, setFilterYear] = useState(dayjs());

  const monthName = filterYear.format("MMMM");
  const yearNumber = filterYear.format("YYYY");

  const { loading, tableData } = useGetRevenueByFilterDashboard({
    filterType,
    date: filterYear.toString(),
  });

  const categories = tableData?.map((data) => data?.name);
  const total = tableData?.map((data) => data?.total);

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 5,
      hover: {
        size: 7,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.3,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    colors: ["#40d388"],
    legend: {
      position: "top",
      horizontalAlign: "right",
      labels: {
        colors: "#666",
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
    },
    xaxis: {
      categories: categories,
    },
    // yaxis: {
    //   min: 0,
    //   max: 120,
    //   tickAmount: 6,
    // },
    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  // console.log("tableData::", tableData)

  const series = [
    {
      name: "Total income",
      data: total,
    },
  ];

  const attStatus = ["month", "year"];

  return (
    <Stack className="chart-container" direction="column" spacing={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          className={t("chart-title")}
          sx={{ cursor: "pointer" }}
          onClick={handleOpen}
        >
          {t("total_revenue")} (
          {filterType === "month" ? (
            <>
              {t("thead_month")}:{" "}
              {language === "en" ? monthName : getKhmerMonth(monthName)}{", "}
              {t("thead_year")}:{" "}
              {language === "en"
                ? yearNumber
                : getKhmerNumber(parseInt(yearNumber))}
            </>
          ) : (
            <>
              {t("thead_year")}:{" "}
              {language === "en"
                ? yearNumber
                : getKhmerNumber(parseInt(yearNumber))}
            </>
          )}
          )
        </Typography>

        {open && (
          <SelectMonthYear
            open={open}
            handleClose={handleClose}
            filterYear={filterYear}
            setFilterYear={setFilterYear}
          />
        )}

        <Stack direction="row" spacing={2} alignItems="center">
          {attStatus.map((data, index) => {
            return (
              <Box
                className="att-card-status"
                key={data}
                onClick={() => setFilterType(data)}
                sx={{
                  cursor: "pointer",
                  backgroundColor: filterType === data ? colors[index] : "#fff",
                  border: `2px solid ${colors[index]}`,
                  color: filterType === data ? "#fff" : colors[index],
                }}
              >
                {data === "month" ? "Month" : "Year"}
              </Box>
            );
          })}
        </Stack>
      </Stack>

      {loading ? (
        <Stack
          direction="column"
          justifyContent="center"
          sx={{ height: "360px" }}
        >
          <LoadingPage />
        </Stack>
      ) : tableData?.length > 1 ? (
        <div id="chart">
          <ReactApexChart
            options={options}
            series={series}
            type="area"
            height={340}
          />
        </div>
      ) : (
        <Stack
          direction="column"
          justifyContent="center"
          sx={{ height: "360px" }}
        >
          <EmptyData />
        </Stack>
      )}
    </Stack>
  );
}
